module.exports = __webpack_public_path__ + "static/assets/5f01fa52fc391ca7bd866ccd013c5cb5.png";